"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { publicEnv } from "@/config/env";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropSize } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import type { FC } from "react";
import { useContext, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import WaveDropActionsAddReaction from "./WaveDropActionsAddReaction";
import WaveDropActionsMarkUnread from "./WaveDropActionsMarkUnread";
import WaveDropActionsRate from "./WaveDropActionsRate";
import WaveDropMobileMenuBoost from "./WaveDropMobileMenuBoost";
import WaveDropMobileMenuDelete from "./WaveDropMobileMenuDelete";
import WaveDropMobileMenuEdit from "./WaveDropMobileMenuEdit";
import WaveDropMobileMenuSetPinnedDrop from "./WaveDropMobileMenuSetPinnedDrop";
import WaveDropMobileMenuOpen from "./WaveDropMobileMenuOpen";
import WaveDropActionsQuickReact from "./WaveDropActionsQuickReact";
interface WaveDropMobileMenuProps {
  readonly drop: ApiDrop;
  readonly isOpen: boolean;
  readonly showReplyAndQuote: boolean;
  readonly longPressTriggered: boolean;
  readonly setOpen: (open: boolean) => void;
  readonly onReply: () => void;
  readonly onAddReaction: () => void;
  readonly onEdit?: (() => void) | undefined;
  readonly onBoostAnimation?: (() => void) | undefined;
  readonly showOpenOption?: boolean | undefined;
  readonly showCopyOption?: boolean | undefined;
}
const WaveDropMobileMenu: FC<WaveDropMobileMenuProps> = t0 => {
  const $ = _c(74);
  const {
    drop,
    isOpen,
    showReplyAndQuote,
    longPressTriggered,
    setOpen,
    onReply,
    onAddReaction,
    onEdit,
    onBoostAnimation,
    showOpenOption: t1,
    showCopyOption: t2
  } = t0;
  const showOpenOption = t1 === undefined ? true : t1;
  const showCopyOption = t2 === undefined ? true : t2;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t3;
  if ($[0] !== drop.id) {
    t3 = drop.id.startsWith("temp-");
    $[0] = drop.id;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isTemporaryDrop = t3;
  const {
    canDelete,
    canSetPinnedDrop
  } = useDropInteractionRules(drop);
  let t4;
  if ($[2] !== drop) {
    t4 = {
      ...drop,
      type: DropSize.FULL,
      stableKey: drop.id,
      stableHash: drop.id
    };
    $[2] = drop;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const extendedDrop = t4;
  const [copied, setCopied] = useState(false);
  let closeMenu;
  let copyToClipboard;
  let isAuthor;
  let showOptions;
  if ($[4] !== activeProfileProxy || $[5] !== connectedProfile || $[6] !== drop || $[7] !== isTemporaryDrop || $[8] !== setOpen) {
    copyToClipboard = () => {
      if (isTemporaryDrop) {
        return;
      }
      const waveDetails = drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      };
      const isDirectMessage = waveDetails.chat?.scope?.group?.is_direct_message ?? false;
      const dropLink = `${publicEnv.BASE_ENDPOINT}${getWaveRoute({
        waveId: drop.wave.id,
        serialNo: drop.serial_no,
        isDirectMessage,
        isApp: false
      })}`;
      if (typeof navigator.clipboard.writeText === "function") {
        navigator.clipboard.writeText(dropLink).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = dropLink;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
      closeMenu();
    };
    isAuthor = connectedProfile?.handle === drop.author.handle && !activeProfileProxy;
    let t5;
    bb0: {
      if (!connectedProfile?.handle) {
        t5 = false;
        break bb0;
      }
      if (activeProfileProxy) {
        t5 = false;
        break bb0;
      }
      if (drop.id.startsWith("temp-")) {
        t5 = false;
        break bb0;
      }
      t5 = connectedProfile.handle === drop.author.handle;
    }
    showOptions = t5;
    closeMenu = () => setOpen(false);
    $[4] = activeProfileProxy;
    $[5] = connectedProfile;
    $[6] = drop;
    $[7] = isTemporaryDrop;
    $[8] = setOpen;
    $[9] = closeMenu;
    $[10] = copyToClipboard;
    $[11] = isAuthor;
    $[12] = showOptions;
  } else {
    closeMenu = $[9];
    copyToClipboard = $[10];
    isAuthor = $[11];
    showOptions = $[12];
  }
  const t5 = `tw-grid tw-grid-cols-1 ${longPressTriggered && "tw-select-none"}`;
  let t6;
  if ($[13] !== closeMenu || $[14] !== extendedDrop) {
    t6 = <WaveDropActionsQuickReact drop={extendedDrop} isMobile={true} onReacted={closeMenu} />;
    $[13] = closeMenu;
    $[14] = extendedDrop;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== extendedDrop || $[17] !== onAddReaction) {
    t7 = <WaveDropActionsAddReaction drop={extendedDrop} isMobile={true} onAddReaction={onAddReaction} />;
    $[16] = extendedDrop;
    $[17] = onAddReaction;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== isTemporaryDrop || $[20] !== onReply || $[21] !== setOpen || $[22] !== showReplyAndQuote) {
    t8 = showReplyAndQuote && <button className={`tw-flex tw-items-center tw-gap-x-4 tw-rounded-xl tw-border-0 tw-bg-iron-950 tw-p-4 ${isTemporaryDrop ? "tw-cursor-default tw-opacity-50" : "active:tw-bg-iron-800"} tw-transition-colors tw-duration-200`} onClick={() => {
      setOpen(false);
      setTimeout(() => onReply(), 250);
    }} disabled={isTemporaryDrop}><svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M7.49 12L3.74 8.248m0 0l3.75-3.75m-3.75 3.75h16.5V19.5" /></svg><span className="tw-text-base tw-font-semibold tw-text-iron-300">Reply</span></button>;
    $[19] = isTemporaryDrop;
    $[20] = onReply;
    $[21] = setOpen;
    $[22] = showReplyAndQuote;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== closeMenu || $[25] !== extendedDrop || $[26] !== onBoostAnimation) {
    t9 = <WaveDropMobileMenuBoost drop={extendedDrop} onBoostChange={closeMenu} onBoostAnimation={onBoostAnimation} />;
    $[24] = closeMenu;
    $[25] = extendedDrop;
    $[26] = onBoostAnimation;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== closeMenu || $[29] !== drop || $[30] !== showOpenOption) {
    t10 = showOpenOption && <WaveDropMobileMenuOpen drop={{
      type: DropSize.FULL,
      ...drop,
      stableHash: drop.id,
      stableKey: drop.id
    }} onOpenChange={closeMenu} />;
    $[28] = closeMenu;
    $[29] = drop;
    $[30] = showOpenOption;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== copied || $[33] !== copyToClipboard || $[34] !== isTemporaryDrop || $[35] !== showCopyOption) {
    t11 = showCopyOption && <button className={`tw-flex tw-items-center tw-gap-x-4 tw-rounded-xl tw-border-0 tw-bg-iron-950 tw-p-4 ${isTemporaryDrop ? "tw-cursor-default tw-opacity-50" : "active:tw-bg-iron-800"} tw-transition-colors tw-duration-200`} onClick={copyToClipboard} disabled={isTemporaryDrop}><svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" /></svg><span className={`tw-text-base tw-font-semibold ${copied ? "tw-text-primary-400" : "tw-text-iron-300"}`}>{copied ? "Copied!" : "Copy link"}</span></button>;
    $[32] = copied;
    $[33] = copyToClipboard;
    $[34] = isTemporaryDrop;
    $[35] = showCopyOption;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== closeMenu || $[38] !== drop) {
    t12 = <WaveDropActionsMarkUnread drop={drop} isMobile={true} onMarkUnread={closeMenu} />;
    $[37] = closeMenu;
    $[38] = drop;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== closeMenu || $[41] !== drop || $[42] !== isAuthor) {
    t13 = !isAuthor && <WaveDropActionsRate drop={drop} isMobile={true} onRated={closeMenu} />;
    $[40] = closeMenu;
    $[41] = drop;
    $[42] = isAuthor;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== closeMenu || $[45] !== drop || $[46] !== onEdit || $[47] !== showOptions) {
    t14 = showOptions && onEdit && drop.drop_type !== ApiDropType.Participatory && <WaveDropMobileMenuEdit drop={drop} onEdit={onEdit} onEditTriggered={closeMenu} />;
    $[44] = closeMenu;
    $[45] = drop;
    $[46] = onEdit;
    $[47] = showOptions;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  let t15;
  if ($[49] !== canSetPinnedDrop || $[50] !== closeMenu || $[51] !== drop) {
    t15 = canSetPinnedDrop && <WaveDropMobileMenuSetPinnedDrop drop={drop} onPinnedDropSet={closeMenu} />;
    $[49] = canSetPinnedDrop;
    $[50] = closeMenu;
    $[51] = drop;
    $[52] = t15;
  } else {
    t15 = $[52];
  }
  let t16;
  if ($[53] !== canDelete || $[54] !== closeMenu || $[55] !== drop) {
    t16 = canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={closeMenu} />;
    $[53] = canDelete;
    $[54] = closeMenu;
    $[55] = drop;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  let t17;
  if ($[57] !== t10 || $[58] !== t11 || $[59] !== t12 || $[60] !== t13 || $[61] !== t14 || $[62] !== t15 || $[63] !== t16 || $[64] !== t5 || $[65] !== t6 || $[66] !== t7 || $[67] !== t8 || $[68] !== t9) {
    t17 = <div className={t5}>{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}</div>;
    $[57] = t10;
    $[58] = t11;
    $[59] = t12;
    $[60] = t13;
    $[61] = t14;
    $[62] = t15;
    $[63] = t16;
    $[64] = t5;
    $[65] = t6;
    $[66] = t7;
    $[67] = t8;
    $[68] = t9;
    $[69] = t17;
  } else {
    t17 = $[69];
  }
  let t18;
  if ($[70] !== isOpen || $[71] !== setOpen || $[72] !== t17) {
    t18 = createPortal(<CommonDropdownItemsMobileWrapper isOpen={isOpen} setOpen={setOpen}>{t17}</CommonDropdownItemsMobileWrapper>, document.body);
    $[70] = isOpen;
    $[71] = setOpen;
    $[72] = t17;
    $[73] = t18;
  } else {
    t18 = $[73];
  }
  return t18;
};
export default WaveDropMobileMenu;